import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import Moment from "react-moment";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import StorageService from "../../../services/Storage";
import { Roles } from "../../../constants/constant.role";

class InvoiceVerificationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: StorageService.getUserDetail() || {},
    };
  }

  handlePageClick = (e) => {
    window.scroll(0, 0);
    this.props.getPendingOfftake(
      e.selected + 1,
      "",
      this.state.year && this.state.year.value
    );
  };

  render() {
    const { invoiceVerificationData } = this.props;
    const { userDetails } = this.state;
    return (
      <div>
        <Row>
          <Col>
            <span className="offtake-title" style={{ fontSize: "16px" }}>
              {invoiceVerificationData.total_count} pending invoices for
              verification
            </span>
          </Col>
        </Row>

        <Row className="c-top-15">
          <Col>
            <table className="table table-bordered table-responsive">
              <thead
                id="invoice-table-head"
                className="offtake-check-table-head"
              >
                <tr>
                  <th>Fleet Name and Code</th>
                  <th>Invoice No.</th>
                  <th> Purchase Date</th>
                  <th> Submission Date</th>
                  <th>Subsidiary No.</th>
                  {userDetails.type === Roles.ZONAL_FLEET_MANAGER_ROLE && (
                    <th>Fleet Manager</th>
                  )}
                </tr>
              </thead>
              <tbody id="invoice-table-body">
                {(invoiceVerificationData.offtake_entries || []).map(
                  (item, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          <span
                            onClick={(e) =>
                              this.props.getPendingOfftakeById(item)
                            }
                            className="Download-Full-Report"
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              fontWeight: "normal",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.owner_name} <br />
                          </span>
                          {item.code}
                        </td>
                        <td>{item.invoice_number}</td>
                        <td>
                          <Moment format="DD MMM YYYY">
                            {item.purchase_date}
                          </Moment>
                        </td>
                        <td>
                          <Moment format="DD MMM YYYY">
                            {item.created_at}
                          </Moment>
                        </td>
                        <td>{item.subsidiary_id}</td>
                        {userDetails.type === Roles.ZONAL_FLEET_MANAGER_ROLE && (
                          <td>{item.fm_name}</td>
                        )}
                      </tr>
                    );
                  }
                )}

                {(invoiceVerificationData.offtake_entries || []).length ===
                  0 && (
                  <tr>
                    <td colSpan="6" style={{ fontSize: "18px", color: "grey" }}>
                      <center>No match found</center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {(invoiceVerificationData.offtake_entries || []).length !== 0 && (
              <div className="pull-right" style={{ display: "flex" }}>
                <span style={{ marginTop: "7px" }}>
                  <span className="showing">Showing </span>
                  <span className="showing-page">
                    {`${invoiceVerificationData.page - 1}1`}-
                    {(invoiceVerificationData.page - 1) * 10 +
                      (invoiceVerificationData.offtake_entries || []).length <
                    10
                      ? "0"
                      : ""}
                    {(invoiceVerificationData.page - 1) * 10 +
                      (invoiceVerificationData.offtake_entries || []).length}
                    &nbsp;of{" "}
                    {invoiceVerificationData.total_count < 10 ? "0" : ""}
                    {invoiceVerificationData.total_count}
                  </span>
                </span>
                &nbsp;&nbsp;&nbsp;
                <ReactPaginate
                  previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                  nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={invoiceVerificationData.pageCount}
                  // pageCount={18}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={this.handlePageClick}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  pageLinkClassName="c-page"
                  previousLinkClassName="c-prev"
                  nextLinkClassName="c-next"
                  breakLinkClassName="c-break-line"
                  activeClassName="active"
                  activeLinkClassName="c-page-link"
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default InvoiceVerificationList;
